import React from 'react';
import PropTypes from 'prop-types';

import {Translate} from '../Translate';
import {getInactiveEventAction} from './InactiveEvent';

const getEventStatusStyles = (props) => {
  const {event} = props;

  const caregiverUpdates = event.caregiverUpdates || [];

  const hasShiftConfirmation = !!caregiverUpdates.find((e) => e.type === 'shiftConfirmation');
  const hasClockInConfirmation = !!caregiverUpdates.find((e) => e.type === 'clockInConfirmation');
  const hasClockOutConfirmationn = !!caregiverUpdates.find((e) => e.type === 'clockOutConfirmation');
  const hasShiftConfirmationMissed = !!caregiverUpdates.find((e) => e.type === 'shiftConfirmationMissed');
  const hasClockInConfirmationMissed = !!caregiverUpdates.find((e) => e.type === 'clockInConfirmationMissed');
  const hasClockOutConfirmationMissed = !!caregiverUpdates.find((e) => e.type === 'clockOutConfirmationMissed');
  const hasRequestedReschedule = !!caregiverUpdates.find(
      (e) => e.type === 'requestReschedule' && e.adminAction?.status !== 'DECLINED',
  );
  const hasRequestedCancel = !!caregiverUpdates.find(
      (e) => e.type === 'requestCancel' && e.adminAction?.status !== 'DECLINED',
  );

  // An inactive event no longer happens, so it outranks anything the caregiver did or requested on it.
  const inactiveAction = getInactiveEventAction(event);

  let status = 'unconfirmed';
  const eventType = event.type;

  if (inactiveAction === 'CANCELLED') {
    status = 'cancelled';
  } else if (inactiveAction === 'DELETED') {
    status = 'deleted';
  } else if (inactiveAction === 'RESCHEDULED') {
    status = 'rescheduled';
  } else if (inactiveAction) {
    status = 'inactive';
  } else if (hasRequestedCancel) {
    status = 'requestCancel';
  } else if (hasRequestedReschedule) {
    status = 'requestReschedule';
  } else if (eventType === 'LIVEIN_EVENT') {
    status = 'liveIn';
  } else if (hasClockOutConfirmationn) {
    status = 'clockOutConfirmation';
  } else if (hasClockInConfirmation) {
    status = 'clockInConfirmation';
  } else if (hasShiftConfirmation) {
    status = 'shiftConfirmation';
  } else if (hasClockOutConfirmationMissed) {
    status = 'clockOutConfirmationMissed';
  } else if (hasClockInConfirmationMissed) {
    status = 'clockInConfirmationMissed';
  } else if (hasShiftConfirmationMissed) {
    status = 'shiftConfirmationMissed';
  }

  let styles = {
    background: '#f5f5f5',
    borderColor: '#9e9e9e',
    textColor: '#616161',
    label: <Translate expression='schedule.eventDetail.Styles.Unconfirmed' />,
  };

  switch (status) {
    case 'liveIn':
      styles = {
        background: '#f9e4c7',
        borderColor: '#8A5F19',
        textColor: '#6b4512',
        label: <Translate expression='schedule.eventDetail.Styles.LiveIn' />,
      };
      break;
    case 'shiftConfirmation':
      styles = {
        background: '#e6f0fc',
        borderColor: '#4285F4',
        textColor: '#1a73e8',
        label: <Translate expression='schedule.eventDetail.Styles.ShiftConfirmation' />,
      };
      break;
    case 'clockInConfirmation':
      styles = {
        background: '#f3e5f5',
        borderColor: '#9c27b0',
        textColor: '#7b1fa2',
        label: <Translate expression='schedule.eventDetail.Styles.ClockInConfirmation' />,
      };
      break;
    case 'clockOutConfirmation':
      styles = {
        background: '#e8f5e9',
        borderColor: '#34A853',
        textColor: '#1e8e3e',
        label: <Translate expression='schedule.eventDetail.Styles.ClockOutConfirmation' />,
      };
      break;
    case 'shiftConfirmationMissed':
      styles = {
        background: '#fff8e1',
        borderColor: '#FBBC04',
        textColor: '#e37400',
        label: <Translate expression='schedule.eventDetail.Styles.ShiftConfirmationMissed' />,
      };
      break;
    case 'clockInConfirmationMissed':
      styles = {
        background: '#fff3e0',
        borderColor: '#f57c00',
        textColor: '#ef6c00',
        label: <Translate expression='schedule.eventDetail.Styles.ClockInConfirmationMissed' />,
      };
      break;
    case 'clockOutConfirmationMissed':
      styles = {
        background: '#fbe9e7',
        borderColor: '#EA4335',
        textColor: '#d93025',
        label: <Translate expression='schedule.eventDetail.Styles.ClockOutConfirmationMissed' />,
      };
      break;
    case 'unconfirmed':
      styles = {
        background: '#f5f5f5',
        borderColor: '#9e9e9e',
        textColor: '#616161',
        label: <Translate expression='schedule.eventDetail.Styles.Unconfirmed' />,
      };
      break;
    case 'requestReschedule':
      styles = {
        background: '#fff8e1',
        borderColor: '#FBBC04',
        textColor: '#e37400',
        label: <Translate expression='schedule.eventDetail.Styles.RequestedReschedule' />,
      };
      break;
    case 'requestCancel':
      styles = {
        background: '#ffebee',
        borderColor: '#EA4335',
        textColor: '#d93025',
        label: <Translate expression='schedule.eventDetail.Styles.RequestedCancel' />,
      };
      break;
    case 'cancelled':
      styles = {
        background: '#ffebee',
        borderColor: '#EA4335',
        textColor: '#d93025',
        label: <Translate expression='schedule.eventDetail.Styles.Cancelled' />,
      };
      break;
    case 'deleted':
      styles = {
        background: '#eeeeee',
        borderColor: '#757575',
        textColor: '#424242',
        label: <Translate expression='schedule.eventDetail.Styles.Deleted' />,
      };
      break;
    case 'rescheduled':
      styles = {
        background: '#fff3e0',
        borderColor: '#FF9800',
        textColor: '#f57c00',
        label: <Translate expression='schedule.eventDetail.Styles.Rescheduled' />,
      };
      break;
    case 'inactive':
      styles = {
        background: '#f5f5f5',
        borderColor: '#9e9e9e',
        textColor: '#616161',
        label: <Translate expression='schedule.eventDetail.Styles.Inactive' />,
      };
      break;
    default:
      break;
  }

  return {
    ...styles,
    isInactive: !!inactiveAction,
  };
};

getEventStatusStyles.propTypes = {
  event: PropTypes.object.isRequired,
};

export default getEventStatusStyles;
